module.exports = __webpack_public_path__ + "static/img/story1.ed7cc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/story1.png
// module id = sQxc
// module chunks = 0